import {
  PromocodeBanner,
  PromocodeBannerModel,
} from '@features/promocode-banner/types';

export function promoCodeBannerSerializer(
  promocodeBannerModels: PromocodeBannerModel[],
): PromocodeBanner[] {
  const promoCodeBanner: PromocodeBanner[] = [];
  promocodeBannerModels.forEach((promocodeBannerModel) => {
    promoCodeBanner.push(promocodeBannerModel.attributes);
  });
  return promoCodeBanner;
}
